var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlashFilled = function SvgFlashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.48.12a1 1 0 0 1 .5 1.05L10.19 6H13a1 1 0 0 1 .7 1.7l-8 8a1 1 0 0 1-1.69-.87l.8-4.83H1a1 1 0 0 1-.66-1.75l9-8a1 1 0 0 1 1.14-.13Z",
    clipRule: "evenodd"
  })));
};
export default SvgFlashFilled;